module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/035-luxembourg-84a7c63494383f5391990da8a09b7883.svg";